<template>
    <van-dialog v-model="show" :title="title" :show-cancel-button="showCancelBtn" :show-confirm-button="showConfirmBtn" class="pt30"
      :confirm-button-text="confirmBtnText" :cancel-button-text="cancelBtnText" :width="width" @confirm="confirm" @cancel="cancel">
      <slot name="top" />
      <div v-if="close">
        <van-icon name="close" size="24px" class="close" @click.stop="cancel" />
      </div>
      <div class="pt30 text-center f20 c222 fw600 pb30">{{msg}}</div>
      <slot name="bottom" />
    </van-dialog>
</template>
<script>
  export default {
    name: "iDialog",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ""
      },
      msg: {
        type: String,
        default: ""
      },
      confirmBtnText: {
        type: String,
        default: "确认"
      },
      cancelBtnText: {
        type: String,
        default: "取消"
      },
      close: {
        type: Boolean,
        default: false
      },
      showCancelBtn: {
        type: Boolean,
        default: true
      },
      showConfirmBtn: {
        type: Boolean,
        default: true
      },
      width: {
        type: String,
        default: "560px"
      }
    },
    watch: {
      value: {
        handler(val) {
          this.show = val;
        },
        immediate: true
      }
    },
    data() {
      return {
        show: false,
        data: null,
        type: ""
      };
    },
    methods: {
      iShow(item, t) {
        this.show = true;
        this.$emit("input", true);
        this.data = item;
        this.type = t;
      },
      confirm() {
        this.$emit("confirm", this.data, this.type);
        this.data = null;
        this.type = "";
      },
      cancel() {
        this.$emit("cancel");
        this.data = null;
        this.type = "";
        this.show = false;
        this.$emit("input", false);
      }
    }
  };
</script>
<style lang="less" scoped>
  /deep/.van-dialog {
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;

    /deep/.van-dialog__footer {
      padding: 30px 120px 50px 120px;
    }

    /deep/.van-button {
      width: 140px;
      height: 50px;
      border-radius: 2px;
      color: #fff;
    }

    /deep/.van-button.van-dialog__confirm {
      background: rgba(15, 110, 234, 1);
    }

    /deep/.van-button.van-dialog__cancel {
      background: rgba(226, 226, 226, 1);
      margin-right: 40px;
    }
  }

  .close {
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }
</style>